import React, { useState } from 'react';
import {
  Box, TextField, Typography, Button, Container, Paper, Grid,
  Snackbar, Alert, CircularProgress, InputAdornment
} from '@mui/material';
import Subject from '@mui/icons-material/Subject';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RoomIcon from '@mui/icons-material/Room';
import axios from 'axios';
import Header from '../header/header';
import './contact.css';
import Footer from '../commun/Footer';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const PageContactModernRadio = () => {
  const [form, setForm] = useState({
    prenom: '',
    nom: '',
    email: '',
    telephone: '',
    objet: '',
    message: ''
  });

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, type: '', message: '' });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleCloseSnackbar = () => setSnackbar({ ...snackbar, open: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nom || !form.email || !form.message) {
      setSnackbar({ open: true, type: 'error', message: 'Merci de remplir les champs obligatoires.' });
      return;
    }

    try {
      setLoading(true);
      await axios.post(`${API_BASE}/api/contact`, form);
      setSnackbar({ open: true, type: 'success', message: 'Votre message a bien été envoyé !' });
      setForm({
        prenom: '',
        nom: '',
        email: '',
        telephone: '',
        objet: '',
        message: ''
      });
    } catch (error) {
      const msg = error.response?.data?.message || 'Erreur lors de l’envoi, veuillez réessayer.';
      setSnackbar({ open: true, type: 'error', message: msg });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
<Box className="hero-image-wrapper">
  <picture>
    <source media="(max-width: 768px)" srcSet="/images/contact/hero-mobile.webp" />
    <source media="(max-width: 1280px)" srcSet="/images/contact/hero-tablet.webp" />
    <img
      src="/images/contact/hero-desktop.webp"
      alt="Bannière contact Cooptaleo"
      className="hero-img"
    />
  </picture>
  <Box className="hero-overlay">
    <Container maxWidth="lg">
      <Box className="hero-content">
        <Typography variant="h3" className="hero-title">
          Contactez-nous
        </Typography>
        <Typography variant="h6" className="hero-subtitle">
          Nous sommes là pour répondre à toutes vos questions.
        </Typography>
      </Box>
    </Container>
  </Box>
</Box>


      <Container maxWidth="lg" className="modern-form-container">
        <Paper className="modern-form-wrapper" elevation={2}>
          <Grid container spacing={4}>
            {/* Formulaire */}
            <Grid item xs={12} md={7}>
              <Typography variant="h5" gutterBottom>Contactez‑nous</Typography>
              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      name="prenom"
                      label="Prénom"
                      fullWidth
                      required
                      value={form.prenom}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon fontSize="small" />
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="nom"
                      label="Nom"
                      fullWidth
                      required
                      value={form.nom}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon fontSize="small" />
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} className="mt-20">
                  <Grid item xs={6}>
                    <TextField
                      name="email"
                      label="E-mail"
                      fullWidth
                      required
                      value={form.email}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EmailIcon fontSize="small" />
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      name="telephone"
                      label="Téléphone"
                      fullWidth
                      value={form.telephone}
                      onChange={handleChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PhoneIcon fontSize="small" />
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                </Grid>

               

               {/* Objet */}
<Box mt={2}>
  <TextField
    name="objet"
    label="Objet"
    required
    fullWidth
    value={form.objet}
    onChange={handleChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Subject fontSize="small" />
        </InputAdornment>
      )
    }}
  />
</Box>

{/* Message */}
<Box mt={2} mb={3}>
  <TextField
    name="message"
    label="Votre message"
    fullWidth
    required
    multiline
    rows={4}
    value={form.message}
    onChange={handleChange}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <InfoOutlinedIcon fontSize="small" />
        </InputAdornment>
      )
    }}
  />
</Box>


                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  className="mt-30"
                  disabled={loading}
                  endIcon={loading && <CircularProgress size={20} color="inherit" />}
                >
                  {loading ? 'Envoi…' : 'Envoyer'}
                </Button>
              </form>
            </Grid>

            {/* Infos + carte */}
            <Grid item xs={12} md={5}>
              <Typography variant="h5" gutterBottom>Besoin de renseignements ?</Typography>
              <Typography variant="body1" className="mb-20">
                Nous sommes à votre disposition pour toutes questions.
              </Typography>

              <Box className="contact-info-row">
                <RoomIcon className="icon-margin" />
                <strong>231 rue Saint-Honoré – 75001 PARIS</strong>
              </Box>
              <Box className="contact-info-row">
                <EmailIcon className="icon-margin" />
                contact@cooptaleo.com
              </Box>
              <Box className="contact-info-row mb-20">
                <PhoneIcon className="icon-margin" />
                01 84 20 20 29
              </Box>

              <Typography variant="body2" gutterBottom>▼ Voir sur la carte :</Typography>
              <Box className="contact-map-box">
                <iframe
                  title="Adresse Cooptaleo"
                  src="https://maps.google.com/maps?q=231+rue+Saint-Honor%C3%A9+%E2%80%93+75001+PARIS&z=15&output=embed"
                  width="100%"
                  height="250"
                  style={{ border: 0 }}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                />
              </Box>
            </Grid>
          </Grid>
        </Paper>
      </Container>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.type} style={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>

      <Footer />
    </>
  );
};

export default PageContactModernRadio;
